import { useNavigate } from "react-router-dom";
import { sidebardata } from "../configs/sidebar";
import { useWidgetManager } from "../hooks/useWidgetManager";

export default function SideMenuComponent() {
  const navigate = useNavigate();
  const { slug } = useWidgetManager();

  return (
    <div className="leftside-menu">
      {/* Brand Logo Light */}
      <a className="logo logo-light">
        <span className="logo-lg mb-3">
          <img src="/assets/images/logo.png" alt="logo" />
        </span>
        <span className="logo-sm">
          <img src="assets/images/logo-sm.png" alt="small logo" />
        </span>
      </a>

      <div
        className="button-sm-hover"
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        title="Show Full Sidebar"
      >
        <i className="ri-checkbox-blank-circle-line align-middle" />
      </div>
      {/* Full Sidebar Menu Close Button */}
      <div className="button-close-fullsidebar">
        <i className="ri-close-fill align-middle" />
      </div>
      {/* Sidebar */}
      <div className="h-100" id="leftside-menu-container" data-simplebar>
        <div>
          <div className="leftbar-user">
            <a href="pages-profile.html">
              <img
                src="assets/images/users/avatar-1.jpg"
                alt="user-image"
                height={42}
                className="rounded-circle shadow-sm"
              />
              <span className="leftbar-user-name mt-2">Хэрэглэгч</span>
            </a>
          </div>
          {/*- Sidemenu */}
          <ul className="side-nav">
            {sidebardata.map((el, i) =>
              !el.slug ? (
                <li className="side-nav-title" key={i}>
                  {el.title}
                </li>
              ) : (
                <li
                  className="side-nav-item"
                  key={i}
                  style={{ cursor: "pointer" }}
                >
                  <a
                    className={`side-nav-link ${
                      slug === el.slug && "text-white"
                    }`}
                    onClick={() => navigate(`/e/${el.slug}`)}
                  >
                    <i className={el.icon} />
                    <span> {el.title} </span>
                  </a>
                </li>
              )
            )}
          </ul>
        </div>

        <div
          className="position-absolute text-muted"
          style={{
            width: "100%",
            position: "absolute",
            bottom: "5%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p className="my-auto"> ©2024 | Powered by </p>
          <img
            className="rounded my-auto ms-2"
            src="/assets/images/e24.png"
            width={20}
            height={20}
          />
          <p className="ms-1 my-auto">E24</p>
        </div>
      </div>
    </div>
  );
}
